import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import PackageColumnComponent from '../../../components/columns/package-column';
import { Multiple } from '../../../components/multiple-text-blurb-for-grid';
import { messages } from './messages';

const PackageColumnWrapper = ({ fulfillmentPlanId }) => {
  const labelConfiguration = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'labelConfiguration',
    }),
  );

  const { packages } = labelConfiguration ?? {};
  const [{ packageTypeId } = {}] = packages ?? [];

  if (packages?.length === 0 || !packageTypeId) {
    return '';
  }

  if (packages?.length > 1) {
    return <Multiple />;
  }

  return <PackageColumnComponent packageTypeId={packageTypeId} />;
};

PackageColumnWrapper.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export const PackageColumn = {
  getMessageDescriptor: () => messages.package,
  id: 'package',

  render: (data, { isExpanded = false, isFirstRow = true } = {}) => {
    if (isExpanded && !isFirstRow) {
      return '';
    }
    return <PackageColumnWrapper fulfillmentPlanId={data.id} />;
  },
};
